import MenuColumn from "./MenuColumn";
import MenuSecondaryItem from "./MenuSecondaryItem";
import "./css/menu-primary-item.css";

export default function menuPrimaryItem(props) {
  const columns = props?.hasColumns
    ? props?.menuItems?.filter((item) => item?.menuItems?.length > 0) ?? []
    : [];

  const hasColumns = columns?.length > 0;
  const children = hasColumns ? [] : props?.menuItems;
  const hasChildren = hasColumns || children?.length > 0;
  const url = hasChildren ? false : props?.url;
  const label = props?.label;
  const isExternalClass = props?.isExternal
    ? "menu-primary-item--external"
    : "";
  const isActiveClass = props?.isActive ? "menu-primary-item--active menu-primary-item--current-page" : "";
  const hasColumnsClass = hasColumns ? "menu-primary-item--has-columns" : "";
  const hasChildrenClass = hasChildren ? "menu-primary-item--has-children" : "";
  const classList = [
    "menu-primary-item",
    `menu-primary-item--${props.type}`,
    // props.type === "button" && "menu-primary-item--button-primary", //TODO:: <--
    isActiveClass,
    isExternalClass,
    hasColumnsClass,
    hasChildrenClass,
  ]
    .filter((item) => !!item)
    .join(" ");

  // TODO:: Implement Button Variant Here
  const buttonClassVariantList = [
    "menu-primary-item__link", // DEFAULT WRITE A LOGIC HERE
  ]
    .filter((item) => !!item)
    .join(" ");

  return (
    <li className={classList} aria-expanded={"false"}>
      <a href={url} className={buttonClassVariantList}>
        <span className="menu-primary-item__label">{label}</span>
        {hasChildren && <span className="menu-primary-item__chevron"></span>}
      </a>

      {hasChildren && (
        <ul className="menu-primary-item__children">
          {columns.map((item, index) => {
            return <MenuColumn key={index} {...item} />;
          })}
          {children.map((item, index) => {
            return <MenuSecondaryItem key={index} {...item} />;
          })}
        </ul>
      )}
    </li>
  );
}
